import { State } from "@store/types";

export function getActionListStateProps(state: State) {
  return state.get("insights_actionList");
}

export function getFocusAreaListStoreProps(state: State) {
  return state.get("insights_focusAreas");
}
